module.exports = __webpack_public_path__ + "media/cp1.d39dcfa8.mp4";